<template>
    <div class="px-0">
        <v-container class="px-0" style="max-width: 100% !important">
            <v-row class="px-3 pt-4 pb-2" >
                <v-col sm="8" md="4" class="py-0">
                    <v-text-field
                        v-model="props.search"
                        append-icon="search"
                        :label="$t('transportation.search')"
                        single-line
                        hide-details
                        class="mb-4 py-0 px-2 mt-0 tools-view-height"
                        style="background-color: var(--v-white_highlight-base); border: 1px solid black; border-radius:5px"
                    ></v-text-field>
                </v-col>
                <v-spacer></v-spacer> 
                <v-col cols="4" align="end" class="py-0">
                    <v-btn class="right white_highlight--text tools-view-height" color="secondary" @click="showExport = true">
                        {{ $t('transportation.export') }}
                    </v-btn>
                </v-col>
            </v-row>
            <v-card class="px-0 size_buttons">
                <v-card-text class="py-3">
                    <v-row>
                        <v-col class="py-0">
                            <datatable :props="{headers:headers, items: props.items, search:props.search}" @methodHandler="methodHandler"></datatable>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>    
            <v-dialog v-model="showExport" persistent max-width="90%" style="width: 500px !important;">
                <v-card style="width:500px !important">
                    <v-card-title class="justify-center mt-4">
                        <v-row align="center" justify="center" class="my-2">
                            <label style="font-size: 16px; font-weight: bold;" class="blue_accent--text text-uppercase">{{$t('transportation.export_data')}}</label>
                        </v-row>
                    </v-card-title>
                    <v-card-text>
                        <v-row align="center" justify="center" class="py-0 my-0 text-center">
                            <v-col cols="6" class="py-0">
                                <datepicker :open_dialog="menu2" :model="report.initial_date" :label="$t('transportation.initial_date')" @model="updateInitialDate($event)" :rules_required="rules_required"></datepicker>
                            </v-col>
                            <v-col cols="6" class="py-0">
                                <datepicker :open_dialog="menu3" :model="report.final_date" :label="$t('transportation.final_date')" @model="updateFinalDate($event)" :rules_required="rules_required"></datepicker>
                            </v-col>
                        </v-row>
                        <div class="d-flex">
                            <v-spacer></v-spacer>
                            <v-btn class="mx-3" text @click="showExport = false">{{ $t('transportation.cancel') }}</v-btn>
                            <v-btn color="secondary" class="white_highlight--text" @click="exportData">
                                {{ $t('transportation.export') }}
                            </v-btn>
                        </div>
                    </v-card-text> 
                    <div class="marker1"></div>
                </v-card>
            </v-dialog>
        </v-container>     
        <v-snackbar v-model="snackbar.visible" :timeout="4000" :color="snackbar.color" style="text-align: center; color: var(--v-accent-base);">{{ snackbar.text }}</v-snackbar>
    </div>
</template>

<script>
export default {
    computed: {
        rules_required(){return [v => !!v || this.$t('create_appointment.validations.required_field')]},
        headers(){
            return [
                { text: this.$t('transportation.entry_date'), align: "center", value: 'arrival_date', class: 'text-uppercase' },
                { text: this.$t('transportation.entry_time'), align: "center", value: 'entry_time', class: 'text-uppercase' },
                { text: this.$t('transportation.customs'), align: "center", value: '', class: 'text-uppercase' },
                { text: this.$t('transportation.patent'), align: "center", value: 'patent_number', class: 'text-uppercase' },
                { text: this.$t('transportation.petition'), align: "center", value: 'petition', class: 'text-uppercase' },
                { text: this.$t('transportation.key'), align: "center", value: '', class: 'text-uppercase' },
                { text: this.$t('transportation.company'), align: "center", value: 'social_reason', class: 'text-uppercase' },
                { text: this.$t('transportation.modulation_date'), align: "center", value: 'modulation_date', class: 'text-uppercase' },
                { text: this.$t('transportation.modulation_time'), align: "center", value: 'modulation_time', class: 'text-uppercase' },
                { text: this.$t('transportation.modulation_operation'), align: "center", value: 'modulation_status', class: 'text-uppercase' },
                { text: this.$t('transportation.padlock'), align: "center", value: 'seal_number', class: 'text-uppercase' },
                { text: this.$t('transportation.revised'), align: "center", value: 'name', class: 'text-uppercase' },
                { text: this.$t('transportation.status'), align: "center", value: '', class: 'text-uppercase' },
                { text: this.$t('transportation.container'), align: "center", value: 'container_number', class: 'text-uppercase' },
                { text: this.$t('transportation.transport'), align: "center", value: 'carrier_line', class: 'text-uppercase' },
                { text: this.$t('transportation.carrier'), align: "center", value: 'drivers_name', class: 'text-uppercase' },
            ];
        } 
    },
    data(){
        return {
            snackbar: {
                visible: false,
                color: 'primary',
                text: ''
            },
            props: {
                search: '',
                items: [],
            },
            report:{
                initial_date: '',
                final_date: ''
            },
            menu2: false,
            menu3: false,
            showExport: false
        }
    },
    mounted(){
        this.index();
        this.$store.state.module = "headers.transportation";
    },
    methods: {
        methodHandler(object){
            this[object.methodName](object.parameters)
        },
        updateInitialDate(value){
            this.report.initial_date = value;
        },
        updateFinalDate(value){
            this.report.initial_date = value;
        },
        index(){
            this.props.items = [];
            this.$store.state.loaderProps.visible = true;
            const lsToken = localStorage.getItem("access_token");
            this.$http.get(this.$store.state.chronosApi + '/customs/customsAdministratorVisitorsES', {headers: {Authorization: lsToken}})
            .then((response) => {
                console.log(response);
                response.data.data.forEach( x => {
                    if (x.reg_date != null && x.reg_date != undefined) x.entry_time = x.reg_date.split("T")[1].substring(0, 8);
                    if (x.modulation_time != null && x.modulation_time != undefined) x.modulation_time = x.modulation_time.split("T")[1];
                    this.props.items.push(x);
                });
            })
            .catch((response) => {
                console.log(response)
                this.$store.state.loaderProps.visible = false;
                if(response.status !== 200){
                    this.snackbar = {
                        visible: true,
                        color: 'red',
                        text: this.$t('pendings.responses.error')
                    }
                }
            }).finally(() => {
                this.$store.state.loaderProps.visible = false;
            });
        },
        exportData(){

        }
    }
}
</script>

<style>
</style>